var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    fill: "#5165FB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 43.95V4.05L9 7.05L12 4.05L15 7.05L18 4.05L21 7.05L24 4.05L27 7.05L30 4.05L33 7.05L36 4.05L39 7.05L42 4.05V43.95L39 40.95L36 43.95L33 40.95L30 43.95L27 40.95L24 43.95L21 40.95L18 43.95L15 40.95L12 43.95L9 40.95ZM11.85 33.2H36.35V30.2H11.85ZM11.85 25.5H36.35V22.5H11.85ZM11.85 17.75H36.35V14.75H11.85ZM9 38.9H39V9.1H9ZM9 9.1V38.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptBlue);
export default __webpack_public_path__ + "static/media/receipt_blue.1860a58113f78cff198d8e3baa8af71b.svg";
export { ForwardRef as ReactComponent };